import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

const ITEMS = [
  {
    src: "/images/g-wedding.jpg",
    title: "Wedding — Mandap & Stage",
    place: "Dibrugarh",
    span: "md:col-span-7 md:row-span-2",
  },
  {
    src: "/images/g-engagement.jpg",
    title: "Engagement — Floral Ring Arch",
    place: "Dibrugarh",
    span: "md:col-span-5 md:row-span-1",
  },
  {
    src: "/images/g-corporate.jpg",
    title: "Corporate — Conference Styling",
    place: "Assam",
    span: "md:col-span-5 md:row-span-1",
  },
  {
    src: "/images/g-birthday.jpg",
    title: "Birthday — Balloon & Bloom Arch",
    place: "Dibrugarh",
    span: "md:col-span-12 md:row-span-1",
  },
  {
    src: "/images/g-real-moon.jpg",
    title: "Wedding — Celestial Moon Stage",
    place: "Utsav Decorators",
    span: "md:col-span-4 md:row-span-2",
  },
  {
    src: "/images/g-real-rajput.jpg",
    title: "Haldi — Royal Rajput Theme",
    place: "Utsav Decorators",
    span: "md:col-span-4 md:row-span-1",
  },
  {
    src: "/images/g-real-mint.jpg",
    title: "Reception — Mint & White Florals",
    place: "Utsav Decorators",
    span: "md:col-span-4 md:row-span-1",
  },
  {
    src: "/images/g-real-emerald.jpg",
    title: "Sangeet — Emerald & Gold",
    place: "Utsav Decorators",
    span: "md:col-span-8 md:row-span-1",
  },
];

export default function Gallery() {
  return (
    <section id="gallery" data-testid="gallery-section" className="border-t border-forest/10 bg-cream py-28 lg:py-36">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="mb-16">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease: EASE }}
            className="mb-4 text-xs font-bold uppercase tracking-[0.3em] text-sage"
          >
            Recent Work
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, delay: 0.1, ease: EASE }}
            className="font-serif text-4xl font-medium tracking-tight text-forest md:text-6xl"
          >
            Days we have <span className="italic text-marigold">dressed</span>
          </motion.h2>
        </div>

        <div className="grid auto-rows-[260px] grid-cols-1 gap-6 md:grid-cols-12">
          {ITEMS.map((item, i) => (
            <motion.figure
              key={item.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.9, delay: i * 0.1, ease: EASE }}
              className={`group relative overflow-hidden border border-forest/15 ${item.span}`}
              data-testid={`gallery-item-${i}`}
            >
              <img
                src={item.src}
                alt={item.title}
                className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                loading="lazy"
              />
              <figcaption className="absolute bottom-5 left-5 translate-y-2 bg-cream/90 px-5 py-3 opacity-0 backdrop-blur-sm transition-all duration-500 group-hover:translate-y-0 group-hover:opacity-100">
                <p className="font-serif text-lg italic text-forest">{item.title}</p>
                <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-sage">{item.place}</p>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
